import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import Dashboard from "../../common/components/layout/Dashboard";
import { InventoryDashboard } from "./inventory-dashboard";

function InventoryDetailsPage() {

    return (
        <ToastProvider>
            <Dashboard>
                <InventoryDashboard />
            </Dashboard>
            <Toast />
        </ToastProvider>
    )
}

export default InventoryDetailsPage
